var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "fixed-bg" }, [
    _c("div", { staticClass: "video-bg one abs-center" }, [
      _c("img", {
        staticClass: "fixed-bg-img abs-center lazyload-bg",
        attrs: { src: _vm.background },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ph0 ph5-m ph5-l flex fixed-height realtive" },
      [_vm._t("contents")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }